// availableAgents.ts

// Renaming the interface to Agent
export interface Agent {
  id: number;
  name: string;
  status: string;
  type?: number;
}

let agents: Agent[] = []; // Renaming the variable to avoid confusion

// Function to set available agents
export const setAvailableAgents = (newAgents: Agent[]) => {
  agents = newAgents;
};

// Function to get available agents
export const getAvailableAgents = () => {
  return agents;
};
